import { render, staticRenderFns } from "./BasePriceInput2.vue?vue&type=template&id=6017f46b&scoped=true"
import script from "./BasePriceInput2.vue?vue&type=script&lang=js"
export * from "./BasePriceInput2.vue?vue&type=script&lang=js"
import style0 from "./BasePriceInput2.vue?vue&type=style&index=0&id=6017f46b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6017f46b",
  null
  
)

export default component.exports